// Added By mlveda--
// Custom Owl - carousel Script apply only on responsive script start
$(window).resize(function(){
  OwlCarouselInit();
});

$(document).ready(function() {
  OwlCarouselInit();
});
function OwlCarouselInit() {
    if (window.matchMedia("(max-width: 767px)").matches) {
        $('#testimonial-carousel').owlCarousel({
            loop: true,
            margin: 0,
            nav: true,
            items: 1,
            dots: false,
            mouseDrag: true,
            touchDrag: true,
        });

        $('.customer-opinion-carousel').each(function () {
            $(this).owlCarousel({
                loop: true,
                margin: 10,
                nav: true,
                items: 1,
                dots: false,
                mouseDrag: true,
                touchDrag: true,
            });
        });
    } else {
        $('#testimonial-carousel').owlCarousel('destroy');
        $('.customer-opinion-carousel').each(function () {
            $(this).owlCarousel('destroy');
        });
    }
}
// Custom Owl - carousel Script apply only on responsive script end
// Custom Accordian Start
document.addEventListener("DOMContentLoaded", function(event) {
   $(".accordian-main-box .accordian-item").click(function() {
    $(this).toggleClass('open').siblings().removeClass('open');
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//   setTimeout(function() {  // Corrected by adding a function wrapper
//     console.log("34------"); // Added a semicolon
//     const inputField = document.querySelector('input[type="number"]');
//     if (inputField) {
//       console.log("34");
//       inputField.addEventListener("input", function(event) {
//         const value = event.target.value;

//         // Prevent 'e', '+', '.' and ensure the number is non-negative
//         const invalidCharacters = /[e+.-]/g; // Added square brackets to avoid parsing issues
//         if (invalidCharacters.test(value) || parseFloat(value) < 0) {
//           event.target.value = value.replace(invalidCharacters, ''); // Corrected regex to avoid incorrect replacement
//         }
//       });
//     }
//   }, 1000); // Adjusted the closing parenthesis and semicolon
// });

// $(document).ready(function(){ 
//   setTimeout(function () {
//    $('.Recenzie .jdgm-widget .jdgm-review-search.jdgm-review-search').attr("placeholder", "akné, menopauza, vlasy...");
//     var content = "<div class='jdgm-review-search-title'>Vyhľadaj problém, ktorý ťa trápi.</div>";
//     $('.Recenzie .jdgm-widget-actions-wrapper').prepend(content);
//     console.log("sddd");
//     },800);
// }); 